import axios from "../plugins/axios";

export default {
  getAllWithHDN() {
    return axios.get("/web_api/v1/document_type/with_hdn").then((response) => response.data);
  },
  getByMortgageProgressGroup(mortgageProgressGroupId, includes = []) {
    return axios.get(`/web_api/v1/document_type/by_mortgage_progress_group/${mortgageProgressGroupId}`, {
      params: {
        include: includes,
      },
    }).then((response) => response.data);
  },
};
